export const env = {
  appTitle: import.meta.env.VITE_APP_TITLE,
  apiUrl: import.meta.env.VITE_API_URL,
  kakaoMapApiKey: import.meta.env.VITE_KAKAO_MAP_APP_KEY,
  naverMapClientId: import.meta.env.VITE_NAVER_MAP_CLIENT_ID,
  isLocal: import.meta.env.DEV && import.meta.env.MODE === "local",
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  mode: import.meta.env.MODE,
}
